import { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router";
import { v4 as uuidv4 } from 'uuid';
import { useSnackbar } from "notistack";
//hooks
import useAuth from "src/hooks/useAuth";
//sections
import CardActionSairEstagio from "src/sections/@dashboard/automacoes/action/CardActionSairEstagio";
import ChatAccept from "src/sections/@dashboard/automacoes/action/ChatAccept";
import ChatAssign from "src/sections/@dashboard/automacoes/action/ChatAssign";
import CardSendMake from "src/sections/@dashboard/automacoes/reaction/CardSendMake";
import CardActionInOutFase from "src/sections/@dashboard/automacoes/action/CardActionInOutFase";
import CardInatividadeFunil from "src/sections/@dashboard/automacoes/action/CardInatividadeFunil";
import CardInatividadeChat from "src/sections/@dashboard/automacoes/action/CardInatividadeChat";
import { DialogLogsAutomacao } from "src/sections/@dashboard/automacoes/DialogLogsAutomacao";
import ChatAddTag from "src/sections/@dashboard/automacoes/reaction/ChatAddTag";
import CardNewLead from "src/sections/@dashboard/automacoes/reaction/CardNewLead";
import CardChangeValue from "src/sections/@dashboard/automacoes/reaction/CardChangeValue";
import ChatKeywordFilter from "src/sections/@dashboard/automacoes/action/ChatKeywordFilter";
import ChatAddNoteComponent from "src/sections/@dashboard/automacoes/reaction/ChatAddNoteComponent";
import CardSendMessage from "src/sections/@dashboard/automacoes/reaction/CardSendMessage";
import CardTransferCard from "src/sections/@dashboard/automacoes/reaction/CardTransferCard";
import HttpRequestComponent from "src/sections/@dashboard/automacoes/reaction/HttpRequestComponent";
import CardReactionMoverCardFunil from "src/sections/@dashboard/automacoes/reaction/CardReactionMoverCardFunil";
import CardActionCampoAtualizado from "src/sections/@dashboard/automacoes/action/CardActionCampoAtualizado";
import CardActionEntrarFase from "src/sections/@dashboard/automacoes/action/CardActionEntrarFase";
import CardFinishChat from "src/sections/@dashboard/automacoes/reaction/CardFinishChat";
import CardTransferChat from "src/sections/@dashboard/automacoes/reaction/CardTransferChat";
import CardCondition from "src/sections/@dashboard/automacoes/reaction/CardCondition";
//components
import SkeletonAutomation from "src/components/skeleton/automacoes/SkeletonAutomation";
import { LabelFromAction } from "src/components/@dashboard/automacoes";
import Iconify from "src/components/Iconify"; // Iconify for icons
//actions
import v2_actionEditarAutomacao from "src/actions/v2/automacoes/v2_actionEditarAutomacao";
import v2_actionAutomacao from "src/actions/v2/automacoes/v2_actionAutomacao";
import v2_actionDeletarAutomacao from "src/actions/v2/automacoes/v2_actionDeletarAutomacao";

//ui
import { Card, CardHeader, CardTitle, CardContent } from "src/@/components/ui/card";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Switch } from "src/@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/@/components/ui/select";
import { AlertInfo } from "src/@/components/shared/AlertInfo";
import { ScrollArea } from "src/@/components/ui/scroll-area";
import { Badge } from "src/@/components/ui/badge";
import ModalConfimacao from "src/components/modal/ModalConfimacao";
import ChatRemoveTag from "src/sections/@dashboard/automacoes/reaction/ChatRemoveTag";
import getActionListaUsuariosByClienteId from "src/actions/usuarios/getActionListaUsuariosByClienteId";
import Scrollbar from "src/components/Scrollbar";
import CardChatTagInOut from "src/sections/@dashboard/automacoes/action/CardChatTagInOut";
import { automationActions, automationEvents } from "src/config";
import CardChatFeedback from "src/sections/@dashboard/automacoes/action/CardChatFeedback";
import CardChatFinish from "src/sections/@dashboard/automacoes/action/CardChatFinish";
import { fDate, fDateTime, fDateTimeSuffix } from "src/utils/formatTime";
import CardResumoConversa from "src/sections/@dashboard/automacoes/action/CardResumoConversa";
import actionListaCanaisPorCliente from "src/actions/clientes/actionListaCanaisPorCliente";
import CardAssignChat from "src/sections/@dashboard/automacoes/reaction/CardAssignChat";
import CardChatFirstMessage from "src/sections/@dashboard/automacoes/action/CardChatFirstMessage";
import CardChamadoGeneric from "src/sections/@dashboard/automacoes/action/CardChamadoGeneric";
import CardChamadoStatusChange from "src/sections/@dashboard/automacoes/action/CardChamadoStatusChange";
import CardFormularioResponse from "src/sections/@dashboard/automacoes/action/CardFormularioResponse";
import CardTarefaGeneric from "src/sections/@dashboard/automacoes/action/CardTarefaGeneric";
import CardTarefaStatusChange from "src/sections/@dashboard/automacoes/action/CardTarefaStatusChange";


const Connector = () => {
  return (
    <div className="relative flex items-center justify-center w-16 h-8 -mx-2">
      {/* Line */}
      <div className="absolute w-full h-0.5 bg-violet-200 dark:bg-violet-500/20"></div>
      {/* First Circle */}
      <div className="absolute left-0 w-3 h-3 bg-violet-500 rounded-full"></div>
      {/* Second Circle */}
      <div className="absolute right-0 w-3 h-3 bg-gray-300 dark:bg-[#383838] rounded-full"></div>
    </div>
  );
}


const diasSemana = [
  { dia: "Domingo", numeroDia: 0 },
  { dia: "Segunda-feira", numeroDia: 1 },
  { dia: "Terça-feira", numeroDia: 2 },
  { dia: "Quarta-feira", numeroDia: 3 },
  { dia: "Quinta-feira", numeroDia: 4 },
  { dia: "Sexta-feira", numeroDia: 5 },
  { dia: "Sábado", numeroDia: 6 },
];

const checkAction = (action, state) => {
  if (!action || !state) {
    console.log("❌ Erro: action ou state estão indefinidos.");
    return false;
  }

  console.log('state detectTypeMsg', state.detectTypeMsg)

  const rules = {
    "from.funnel.card.field.change": () =>
      state.pipelineId !== null &&
      state.stageId !== null &&
      Array.isArray(state.valuesFields) &&
      state.valuesFields.length > 0,

    "from.funnel.card.create": () =>
      true,

    "from.jobs.birthdate": () =>
      true,

    "from.chat.firstMessage": () =>
      Array.isArray(state.chatChannels) && state.chatChannels.length > 0,

    "from.chat.finish": () =>
      true,

    "from.chat.tag.inOut": () =>
      Array.isArray(state.tags) && state.tags.length > 0,

    "from.chat.contains": () =>
      (state.detectTypeMsg === true && state.detectTypeMsgTypes && state.detectTypeMsgTypes.length > 0) ||
      (state.aiDetect === true && state.aiDetectContext && state.aiDetectContext.trim() !== "") ||
      ((Array.isArray(state.chatKeywords) && state.chatKeywords.length > 0) &&
        state.chatKeywords.length > 0 &&
        (Array.isArray(state.chatStatus) && state.chatStatus.length > 0) &&
        state.chatStatus.length > 0),
    "from.chat.feedback": () =>
      (Array.isArray(state.feedbacks) && state.feedbacks.length > 0),

    "from.funnel.card.out.stage": () =>
      state.pipelineId !== null && state.stageId !== null,

    "from.funnel.card.in.stage": () =>
      state.pipelineId !== null && state.stageId !== null,

    "from.funnel.card.inOut.stage": () =>
      state.pipelineId !== null &&
      state.stageId !== null &&
      state.stageIdTarget !== null,

    "from.chat.accept": () =>
      Array.isArray(state.chatUsersAccept) &&
      state.chatUsersAccept.length > 0,

    "from.chat.assign": () =>
      (Array.isArray(state.chatUsersAssign) && state.chatUsersAssign.length > 0) ||
      (Array.isArray(state.chatDepartamentsAssign) && state.chatDepartamentsAssign.length > 0),

    "from.chat.inactivity": () =>
      (Array.isArray(state.chatStatus) && state.chatStatus.length > 0) &&
      state.chatStatus.length > 0 &&
      state.timeInativity !== null,

    "from.funnel.card.inativity": () =>
      state.pipelineId !== null &&
      (Array.isArray(state.stage_ids) && state.stage_ids.length > 0) &&
      state.stage_ids.length > 0,

    "from.chats.resume": () =>
      state.timeResume !== null &&
      (Array.isArray(state.chatStatus) && state.chatStatus.length > 0) &&
      state.chatStatus.length > 0 &&
      state.chatClientId !== null,

    "from.chamado.create": () => true,
    "from.chamado.finish": () => true,
    "from.chamado.comment": () => true,
    "from.chamado.status.change": () => true,
    "from.formulario.response.submit": () => true,
    "from.tarefa.create": () => true,
    "from.tarefa.finish": () => true,
    "from.tarefa.status.change": () => true,

  };


  if (!rules[action]) {
    console.log(`⚠️ Ação desconhecida: ${action}`);
    return false;
  }


  const result = rules[action]();

  return result;
};

export default function Automacao() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { user, cliente } = useAuth();
  const [actionPhase, setActionPhase] = useState(null);
  const [reactionPhase, setReactionPhase] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [automacao, setAutomacao] = useState(null);
  const [editEvent, setEditEvent] = useState(true);
  const [loading, setLoading] = useState(false);
  const [openModalConfirmacao, setOpenModalConfirmacao] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [canais, setCanais] = useState([]);

  const [users, setUsers] = useState([]);

  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });


  const [actionState, setActionState] = useState({
    pipelineId: null,
    stageId: null,
    pipelineIdTarget: null,
    stageIdTarget: null,
    valuesFields: [],
    chatUsersAccept: [],
    chatKeywords: [],
    cardTransferUsers: [],
    chatDepartamentsAssign: [],
    chatUsersAssign: [],
    timeInativity: 5,
    inactivityType: "cliente",
    timeUnitInativity: 1,
    stage_ids: [],
    chatStatus: [],
    tags: [],
    actionTag: null,
    ignorePreviousActivities: true,
    executeOnlyTime: true,
    schedule: diasSemana.map(({ dia, numeroDia }) => ({
      dia,
      numeroDia,
      ativo: true,
      inicio: "08:00",
      fim: "18:00",
    })),
    scheduleCustom: false,
    feedbacks: [],
    aiDetect: false,
    aiDetectContext: "",
    detectTrigger: false,
    detectTypeMsg: false,
    detectTypeMsgTypes: [],
    limitMsgAgent: null,
    limitMsgClient: null,
    chatClientId: null,
    periodSendResume: null,
    aiAnalysisSource: "cliente",
    aiIntelligenceLevel: "basico",
    campaignId: null,
    chatChannels: [],
    chamadoUsersAssign: [],
    chamadoTargetStatus: [],
    chamadoTipo: null,
    chamadoCaixaEntradaId: null,
    formularioIds: [],
    tarefaUsersAssign: [],
    tarefaTargetStatus: []
  });


  const buscarListaCanais = async () => {
    try {
      const response = await actionListaCanaisPorCliente(user?.clienteId)
      setCanais(response.data.data)
    } catch (error) {
      console.log(error)
    }
  }

  const isActionValid = checkAction(actionPhase?.value, actionState);

  // Available variables for variable inputs (HTTP Request, etc)
  const availableVariables = useMemo(() => {
    const vars = [
      // System variables
      { key: 'automacao.id', description: 'ID da automação', type: 'Sistema' },
      { key: 'automacao.name', description: 'Nome da automação', type: 'Sistema' },
      { key: 'cliente.id', description: 'ID do cliente', type: 'Sistema' },
      // Contact/Chat variables
      { key: 'contato.id', description: 'ID do contato', type: 'Contato' },
      { key: 'contato.nome', description: 'Nome do contato', type: 'Contato' },
      { key: 'contato.telefone', description: 'Telefone do contato', type: 'Contato' },
      { key: 'contato.email', description: 'Email do contato', type: 'Contato' },
      { key: 'chat.id', description: 'ID do chat', type: 'Chat' },
      { key: 'chat.status', description: 'Status do chat', type: 'Chat' },
      { key: 'chat.ultimaMensagem', description: 'Última mensagem recebida', type: 'Chat' },
      { key: 'chat.canal', description: 'Canal do chat (WhatsApp, etc)', type: 'Chat' },
      // Funnel/Card variables
      { key: 'card.id', description: 'ID do card no funil', type: 'Funil' },
      { key: 'card.titulo', description: 'Título do card', type: 'Funil' },
      { key: 'card.valor', description: 'Valor do card', type: 'Funil' },
      { key: 'pipeline.id', description: 'ID do pipeline', type: 'Funil' },
      { key: 'pipeline.nome', description: 'Nome do pipeline', type: 'Funil' },
      { key: 'stage.id', description: 'ID da etapa', type: 'Funil' },
      { key: 'stage.nome', description: 'Nome da etapa', type: 'Funil' },
      // User variables
      { key: 'usuario.id', description: 'ID do usuário responsável', type: 'Usuário' },
      { key: 'usuario.nome', description: 'Nome do usuário', type: 'Usuário' },
    ];

    // Add trigger-specific variables based on actionPhase
    if (actionPhase?.value === 'from.chat.contains') {
      vars.push({ key: 'trigger.mensagem', description: 'Mensagem que ativou o gatilho', type: 'Gatilho' });
      vars.push({ key: 'trigger.keywords', description: 'Palavras-chave detectadas', type: 'Gatilho' });
    }
    if (actionPhase?.value === 'from.chat.feedback') {
      vars.push({ key: 'trigger.feedback', description: 'Feedback recebido', type: 'Gatilho' });
      vars.push({ key: 'trigger.nota', description: 'Nota do feedback', type: 'Gatilho' });
    }

    return vars;
  }, [actionPhase]);

  async function getUsers() {
    try {
      const response = await getActionListaUsuariosByClienteId(user?.clienteId);
      setUsers(response.data.usuarios);

    } catch (error) {
      console.log(error);
    }
  }



  async function deleteAutomacao() {
    try {
      setLoadingDelete(true);
      await v2_actionDeletarAutomacao(id);
      navigate('/dashboard/automacoes')
      setLoadingDelete(false);
    } catch (err) {
      setLoadingDelete(false);
      console.log(err);
    }
  }

  const [blocks, setBlocks] = useState([]);
  const filteredActions = automationActions.filter(action => action.accepts.includes(actionPhase?.value));

  useEffect(() => {
    console.log('actionState 2', actionState)
  }, [actionState, blocks])


  useEffect(() => {
    buscarListaCanais();
    const fetchAutomation = async () => {
      try {
        setLoading(true);
        const response = await v2_actionAutomacao(id);
        const automacaoData = response.data.data;

        // Atualize os blocos com os valores obtidos
        if (automacaoData?.params?.to) {
          const mappedBlocks = automacaoData.params.to.map(block => ({
            id: uuidv4(), // ou use um ID único fornecido pela API
            value: block.value,
            data: block.data
          }));
          setBlocks(mappedBlocks);
        }

        // Preencha outros estados, se necessário
        if (automacaoData?.params?.from) {
          const action = automationEvents.find(event => event.value === automacaoData.params.from.action);
          setActionPhase(action);
          setSelectedEvent(action);

          if (automacaoData.params.from) {
            setActionState(automacaoData.params.from);
          } else {
            setActionState({
              ...automacaoData.params.from,
              executeOnlyTime: true,
              schedule: diasSemana.map(({ dia, numeroDia }) => ({
                dia,
                numeroDia,
                ativo: true,
                inicio: "08:00",
                fim: "18:00",
              }))
            });
          }


          if (!automacaoData?.params?.from?.schedule || automacaoData?.params?.from?.schedule.length === 0) {
            setActionState({
              ...automacaoData.params.from, schedule: diasSemana.map(({ dia, numeroDia }) => ({
                dia,
                numeroDia,
                ativo: true,
                inicio: "08:00",
                fim: "18:00",
              }))
            })
          }
        }


        // Atualize o estado geral de automação
        setAutomacao(automacaoData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Erro ao carregar automação:", error);
      }
    };
    getUsers();

    if (id) {
      fetchAutomation();
    }
  }, [id]); // Certifique-se de que a dependência está correta

  const groupedEvents = automationEvents.reduce((groups, event) => {
    const category = event.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(event);
    return groups;
  }, {});

  const groupedActions = filteredActions.reduce((groups, action) => {
    if (!groups[action.category]) {
      groups[action.category] = [];
    }
    groups[action.category].push(action);
    return groups;
  }, {});



  // Função para adicionar um novo bloco
  const addBlock = () => {
    setBlocks((prevBlocks) => [
      ...prevBlocks,
      {
        id: uuidv4(),
        value: null,
        data: null
      },
    ]);
  };
  // Função para remover um bloco
  const removeBlock = (id) => {
    setBlocks(blocks.filter((block) => block.id !== id));
  };

  // Função para atualizar o tipo do bloco
  const updateBlockType = (id, value) => {
    setBlocks(
      blocks.map((block) => {
        if (block.id !== id) return block;
        const updated = { ...block, value };
        // Initialize data with defaults for condition blocks
        if (value === 'to.condition') {
          updated.data = {
            conditions: [{ type: 'String', value1: '', operation: 'Contains', value2: '' }],
            conditionLogic: 'and',
            truePath: [],
            falsePath: []
          };
        }
        return updated;
      })
    );
  };

  const handleChangeAction = (event) => {
    if (event.name === "pipeline_id") {
      setActionState({ ...actionState, pipelineId: event.value });
    } else if (event.name === "stage_id") {
      setActionState({ ...actionState, stageId: event.value });
    } else if (event.name === "valuesFields") {
      setActionState({ ...actionState, valuesFields: event.value });
    } else if (event.name === "chatUsersAccept") {
      setActionState({ ...actionState, chatUsersAccept: event.value });
    } else if (event.name === "chatKeywords") {
      setActionState({ ...actionState, chatKeywords: event.value });
    } else if (event.name === "pipeline_id_target") {
      setActionState({ ...actionState, pipelineIdTarget: event.value });
    } else if (event.name === "stage_id_target") {
      setActionState({ ...actionState, stageIdTarget: event.value });
    } else if (event.name === "cardTransferUsers") {
      setActionState({ ...actionState, cardTransferUsers: event.value });
    } else if (event.name === "chatDepartamentsAssign") {
      setActionState({ ...actionState, chatDepartamentsAssign: event.value });
    } else if (event.name === "chatUsersAssign") {
      setActionState({ ...actionState, chatUsersAssign: event.value });
    } else if (event.name === "timeInativity") {
      setActionState({ ...actionState, timeInativity: event.value });
    } else if (event.name === "timeUnitInativity") {
      setActionState({ ...actionState, timeUnitInativity: event.value });
    } else if (event.name === "stage_ids") {
      setActionState({ ...actionState, stage_ids: event.value });
    } else if (event.name === "inactivityValue") {
      setActionState({ ...actionState, timeInativity: event.value });
    } else if (event.name === "ignorePreviousActivities") {
      setActionState({ ...actionState, ignorePreviousActivities: event.value });
    } else if (event.name === "chatStatus") {
      setActionState({ ...actionState, chatStatus: event.value });
    } else if (event.name === "executeOnlyTime") {
      setActionState({ ...actionState, executeOnlyTime: event.value });
    } else if (event.name === "tags") {
      setActionState({ ...actionState, tags: event.value });
    } else if (event.name === "actionTag") {
      setActionState({ ...actionState, actionTag: event.value });
    } else if (event.name === "scheduleCustom") {
      setActionState({ ...actionState, scheduleCustom: event.value });
    } else if (event.name === "schedule") {
      setActionState({ ...actionState, schedule: event.value });
    } else if (event.name === "feedbacks") {
      setActionState({ ...actionState, feedbacks: event.value });
    } else if (event.name === "aiDetect") {
      setActionState({ ...actionState, aiDetect: event.value });

    } else if (event.name === "aiDetectContext") {
      setActionState({ ...actionState, aiDetectContext: event.value });
    } else if (event.name === "aiSilent") {
      setActionState({ ...actionState, aiSilent: event.value });
    } else if (event.name === "limitMsgAgent") {
      setActionState({ ...actionState, limitMsgAgent: event.value });
    } else if (event.name === "limitMsgClient") {
      setActionState({ ...actionState, limitMsgClient: event.value });
    } else if (event.name === "timeResume") {
      setActionState({ ...actionState, timeResume: event.value });
    } else if (event.name === "chatClientId") {
      setActionState({ ...actionState, chatClientId: event.value });
    } else if (event.name === "periodSendResume") {
      setActionState({ ...actionState, periodSendResume: event.value });
    } else if (event.name === "aiAnalysisSource") {
      setActionState({ ...actionState, aiAnalysisSource: event.value });
    } else if (event.name === "aiIntelligenceLevel") {
      setActionState({ ...actionState, aiIntelligenceLevel: event.value });
    } else if (event.name === "detectTypeMsg") {
      console.log('detectTypeMsg', event.value)
      setActionState({ ...actionState, detectTypeMsg: event.value });
    } else if (event.name === "detectTypeMsgTypes") {
      console.log('detectTypeMsgTypes', event.value)
      setActionState({ ...actionState, detectTypeMsgTypes: event.value });
      if (event.value) {
        setActionState({ ...actionState, aiDetect: false });
      }
    } else if (event.name === "detectTrigger") {
      console.log('detectTrigger', event.value)
      setActionState({ ...actionState, detectTrigger: event.value });
    } else if (event.name === "linkToChatUser") {
      setActionState({ ...actionState, linkToChatUser: event.value });
    } else if (event.name === "chatChannels") {
      setActionState({ ...actionState, chatChannels: event.value });
    } else if (event.name === "inactivityType") {
      setActionState({ ...actionState, inactivityType: event.value });
    } else if (event.name === "chatTags") {
      setActionState({ ...actionState, chatTags: event.value });
    } else if (event.name === "executeValidityValue") {
      setActionState(prev => ({ ...prev, executeValidityValue: event.value }));
    } else if (event.name === "executeValidityUnit") {
      setActionState(prev => ({ ...prev, executeValidityUnit: event.value }));
    } else if (event.name === "isExecuteValidity") {
      setActionState(prev => ({ ...prev, isExecuteValidity: event.value }));
    } else if (event.name === "chamadoTipo") {
      setActionState(prev => ({ ...prev, chamadoTipo: event.value, chamadoCaixaEntradaId: null }));
    } else if (event.name === "chamadoCaixaEntradaId") {
      setActionState(prev => ({ ...prev, chamadoCaixaEntradaId: event.value }));
    } else if (event.name === "chamadoUsersAssign") {
      setActionState(prev => ({ ...prev, chamadoUsersAssign: event.value }));
    } else if (event.name === "chamadoTargetStatus") {
      setActionState(prev => ({ ...prev, chamadoTargetStatus: event.value }));
    } else if (event.name === "formularioIds") {
      setActionState(prev => ({ ...prev, formularioIds: event.value }));
    } else if (event.name === "tarefaUsersAssign") {
      setActionState(prev => ({ ...prev, tarefaUsersAssign: event.value }));
    } else if (event.name === "tarefaTargetStatus") {
      setActionState(prev => ({ ...prev, tarefaTargetStatus: event.value }));
    }
  }

  const handleChangeBlock = (id, event) => {
    if (event.name === "chatFiles") {
      setBlocks((prevBlocks) =>
        prevBlocks.map((block) => {
          if (block.id === id) {
            let updatedChatFiles;
            if (event.action === "delete") {
              // Filtra os arquivos para remover o arquivo especificado
              updatedChatFiles = event.value;
            } else {
              // Adiciona novos arquivos
              updatedChatFiles = [
                ...(block.data?.chatFiles || []),
                ...(Array.isArray(event.value) ? event.value : [event.value])
              ];
            }
            return {
              ...block,
              data: {
                ...block.data,
                [event.name]: updatedChatFiles
              }
            };
          }
          return block;
        })
      );
      return;
    }
    setBlocks((prevBlocks) =>
      prevBlocks.map((block) =>
        block.id === id
          ? { ...block, data: { ...block.data, [event.name]: event.value } }
          : block
      )
    );
  };


  const handleEditAutomation = async () => {
    if (blocks.length === 0 || !actionPhase) {
      enqueueSnackbar("Adicione uma ação para salvar a automação", { variant: "error" });
      return;
    }

    // Validar se algum bloco com useChannel=true não tem chatChannel
    const blockWithInvalidChannel = blocks.find(block =>
      block.value === "to.chat.sendMessage" &&
      block.data?.useChannel === true &&
      !block.data?.chatChannel
    );

    if (blockWithInvalidChannel) {
      enqueueSnackbar("Selecione um canal de envio quando a opção 'Selecionar canal específico' estiver ativada", { variant: "error" });
      return;
    }

    let data = {
      scope: {
        status: automacao?.status,
        name: automacao?.name,
        params: {
          from: {
            action: actionPhase.value,
            ...actionState
          },
          to: blocks
        }
      }

    }
    try {
      await v2_actionEditarAutomacao(id, data);
      enqueueSnackbar("Automação editada com sucesso!", { variant: "success" });
    } catch (error) {
      console.error("Erro ao editar automação:", error);
      enqueueSnackbar("Erro ao salvar automação", { variant: "error" });
      return;
    }

  }

  return (
    <>
      <ModalConfimacao
        open={openModalConfirmacao}
        loading={loadingDelete}
        onClose={() => {
          setOpenModalConfirmacao(false);
        }}
        onConfirm={async () => {
          try {
            await deleteAutomacao(id);
            setOpenModalConfirmacao(false);
          } catch (err) {
            console.log(err);
          }
        }}
        loadingFinalizar={false}
        mensagem={'Deseja mesmo excluir?'}
      />

      <div className="h-screen flex flex-col">
        {/* Header */}
        <div className="h-14 bg-white dark:bg-[#222529] border-b border-gray-200 dark:border-[#383838] flex items-center px-5 justify-between shrink-0 z-10 shadow-sm">
          {/* Esquerda: Voltar + Nome */}
          <div className="flex items-center gap-3 min-w-0 flex-1">
            <Button variant="ghost" size="icon" className="shrink-0 h-8 w-8" onClick={() => navigate('/dashboard/automacoes')}>
              <Iconify icon="mdi:arrow-left" width={18} />
            </Button>
            <div className="flex flex-col min-w-0">
              <input
                type="text"
                value={automacao?.name || ''}
                onChange={(e) => {
                  setAutomacao({ ...automacao, name: e.target.value });
                  setEditEvent(true);
                }}
                placeholder="Nome da automação"
                className="font-semibold text-sm text-slate-800 dark:text-[#D1D2D3] bg-transparent border-none outline-none focus:ring-0 p-0 w-full placeholder:text-slate-400 truncate"
              />
              <span className="text-[10px] text-slate-400 dark:text-[#8B8C8E]">Automação</span>
            </div>
          </div>

          {/* Centro: Toggle de visualização */}
          <div className="flex items-center bg-gray-100 dark:bg-[#2A2D31] rounded-lg p-0.5 mx-4 shrink-0">
            <button
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium bg-white dark:bg-[#383838] text-violet-600 dark:text-violet-400 shadow-sm transition-colors"
            >
              <Iconify icon="mdi:view-list-outline" width={15} />
              Clássico
            </button>
            <button
              onClick={() => navigate(`/dashboard/automacoes/workflow/${id}`)}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium text-gray-500 dark:text-[#ABABAD] hover:text-gray-700 dark:hover:text-white transition-colors"
            >
              <Iconify icon="mdi:graph-outline" width={15} />
              Workflow
            </button>
          </div>

          {/* Direita: Status + Data + Ações */}
          <div className="flex items-center gap-3 shrink-0">
            <div className="flex items-center gap-2">
              <Switch
                checked={automacao?.status}
                onClick={(event) => {
                  event.stopPropagation();
                  setAutomacao({ ...automacao, status: !automacao.status });
                  setEditEvent(true);
                }}
              />
              {automacao?.status ? (
                <span className="text-xs font-medium text-emerald-600 dark:text-emerald-400">Ativo</span>
              ) : (
                <span className="text-xs font-medium text-red-500 dark:text-red-400">Inativo</span>
              )}
            </div>

            {automacao?.create_at && (
              <>
                <div className="w-px h-5 bg-gray-200 dark:bg-[#383838]" />
                <span className="text-[10px] text-slate-400 dark:text-[#8B8C8E] whitespace-nowrap">{fDateTime(automacao.create_at)}</span>
              </>
            )}

            <div className="w-px h-5 bg-gray-200 dark:bg-[#383838]" />

            <div className="flex items-center gap-1.5">
              <Button
                size="icon"
                variant="ghost"
                className="h-8 w-8 text-slate-400 hover:text-red-600 dark:text-[#8B8C8E] dark:hover:text-red-400"
                onClick={() => setOpenModalConfirmacao(true)}
              >
                <Iconify icon="mdi:delete-outline" width={18} />
              </Button>
              <DialogLogsAutomacao
                automationId={id}
                user={user}
              />
            </div>

            {editEvent && (
              <Button
                size="sm"
                className="bg-violet-600 hover:bg-violet-700 text-white text-xs h-8 gap-1.5"
                onClick={handleEditAutomation}
              >
                <Iconify icon="mdi:content-save-outline" /> Salvar
              </Button>
            )}
          </div>
        </div>

        <div className="w-[90%] mx-auto py-4 flex flex-col flex-1 min-h-0">
        {
          loading ? (
            <SkeletonAutomation />
          ) : (
            <div className="flex flex-1 min-h-0">
              {/* Left column (Event triggers) */}
              <div className="min-w-[550px] flex flex-col">
                <Card className="w-full flex flex-col flex-1 min-h-0">
                  <CardHeader>
                    <div className="flex justify-between">
                      <CardTitle>Sempre que...</CardTitle>
                      {actionPhase && automacao?.draft && (
                        <Button
                          onClick={() => {
                            setActionPhase(null);
                            setBlocks([]);
                            setActionState(
                              {
                                pipelineId: null,
                                stageId: null,
                                valuesFields: [],
                                chatUsersAccept: [],
                                chatKeywords: []
                              }
                            )
                          }} variant="ghost">
                          <Iconify icon="ic:baseline-close" />
                        </Button>
                      )}
                    </div>
                  </CardHeader>
                  <CardContent className="flex-1 min-h-0 overflow-hidden">
                    <Scrollbar className="h-full">
                      {actionPhase?.value === "from.funnel.card.in.stage" && <CardActionEntrarFase
                        users={usersFormatted}
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                      />}
                      {actionPhase?.value === "from.funnel.card.out.stage" && <CardActionSairEstagio
                        users={usersFormatted}
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                      />}
                      {actionPhase?.value === "from.chat.finish" && <CardChatFinish
                        users={usersFormatted}
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                      />}
                      {actionPhase?.value === "from.funnel.card.inOut.stage" && <CardActionInOutFase
                        users={usersFormatted}
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                      />}
                      {actionPhase?.value === "from.funnel.card.create" && <div>
                        <LabelFromAction>
                          {actionPhase.name}
                        </LabelFromAction>
                      </div>}

                      {actionPhase?.value === "from.jobs.birthdate" && <div>
                        <LabelFromAction>
                          {actionPhase.name}
                        </LabelFromAction>
                      </div>}

                      {actionPhase?.value === "from.chat.firstMessage" && <CardChatFirstMessage
                        users={usersFormatted}
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                      />}


                      {actionPhase?.value === "from.funnel.card.field.change" && <CardActionCampoAtualizado
                        users={usersFormatted}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                        cliente={cliente}
                        actionPhase={actionPhase}
                      />}
                      {actionPhase?.value === "from.chat.accept" && (
                        <ChatAccept
                          users={usersFormatted}
                          actionPhase={actionPhase}
                          user={user}
                          changeActionState={handleChangeAction}
                          actionState={actionState}
                        />
                      )}
                      {actionPhase?.value === "from.chat.tag.inOut" && (
                        <CardChatTagInOut
                          actionPhase={actionPhase}
                          user={user}
                          changeActionState={handleChangeAction}
                          actionState={actionState}
                          users={usersFormatted}
                        />
                      )}
                      {actionPhase?.value === "from.chat.assign" && (
                        <ChatAssign
                          actionPhase={actionPhase}
                          user={user}
                          changeActionState={handleChangeAction}
                          actionState={actionState}
                        />
                      )
                      }
                      {actionPhase?.value === "from.chat.contains" && <ChatKeywordFilter
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                        user={user}
                        cliente={cliente}
                      />}

                      {actionPhase?.value === "from.chat.feedback" && <CardChatFeedback
                        actionPhase={actionPhase}
                        actionState={actionState}
                        changeActionState={handleChangeAction}
                        user={user}
                        users={usersFormatted}
                      />}

                      {actionPhase?.value === "from.funnel.card.inativity" && (
                        <CardInatividadeFunil
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          diasSemana={diasSemana}
                        />
                      )}

                      {actionPhase?.value === "from.chat.inactivity" && (
                        <CardInatividadeChat
                          user={user}
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          diasSemana={diasSemana}
                        />
                      )}

                      {actionPhase?.value === "from.chats.resume" && (
                        <CardResumoConversa
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          user={user}
                          diasSemana={diasSemana}
                        />
                      )}

                      {(actionPhase?.value === "from.chamado.create" || actionPhase?.value === "from.chamado.finish" || actionPhase?.value === "from.chamado.comment") && (
                        <CardChamadoGeneric
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          users={usersFormatted}
                          user={user}
                        />
                      )}

                      {actionPhase?.value === "from.chamado.status.change" && (
                        <CardChamadoStatusChange
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          users={usersFormatted}
                          user={user}
                        />
                      )}

                      {actionPhase?.value === "from.formulario.response.submit" && (
                        <CardFormularioResponse
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          user={user}
                        />
                      )}

                      {(actionPhase?.value === "from.tarefa.create" || actionPhase?.value === "from.tarefa.finish") && (
                        <CardTarefaGeneric
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          users={usersFormatted}
                        />
                      )}

                      {actionPhase?.value === "from.tarefa.status.change" && (
                        <CardTarefaStatusChange
                          actionPhase={actionPhase}
                          actionState={actionState}
                          changeActionState={handleChangeAction}
                          users={usersFormatted}
                        />
                      )}

                      {!actionPhase && (
                        <div className="p-4 space-y-6">
                          {Object.keys(groupedEvents).map((category, index) => (
                            <div key={index}>
                              <div className="flex items-center justify-between px-1 mb-3">
                                <span className="text-[15px] font-medium text-slate-700 dark:text-[#D1D2D3] capitalize">{category}</span>
                              </div>
                              <div className="flex flex-col gap-2 w-11/12">
                                {groupedEvents[category].map((event, index) => (
                                  <div
                                    key={index}
                                    onClick={() => {
                                      setActionPhase(event);
                                      setSelectedEvent(event);
                                      if (["from.funnel.card.inativity", "from.chat.inactivity"].includes(event.value)) {
                                        handleChangeAction({ name: "executeOnlyTime", value: true })
                                        handleChangeAction({ name: "ignorePreviousActivities", value: true })
                                      }
                                    }}
                                    className={`
                                            group flex flex-row items-center gap-4 px-4 py-3 rounded-lg border border-gray-200 dark:border-[#383838] bg-white dark:bg-transparent
                                            hover:border-violet-500 hover:bg-slate-50 dark:hover:bg-[#222529]
                                            cursor-pointer transition-all duration-200
                                            ${selectedEvent === event ? 'border-violet-500 bg-slate-50 dark:bg-[#222529]' : ''}
                                        `}
                                  >
                                    <div className="text-slate-800 dark:text-[#ABABAD] flex items-center justify-center shrink-0">
                                      <Iconify icon={event.icon} width={20} height={20} className="" />
                                    </div>
                                    <div className="flex-1 flex items-center justify-between">
                                      <div className="text-[13px] text-slate-800 dark:text-[#ABABAD] text-left font-medium">
                                        {event.name}
                                      </div>
                                      {event.ai && (
                                        <div className="flex justify-center ml-2 shrink-0">
                                          <Iconify className="text-violet-700" icon={'mingcute:ai-line'} width={18} />
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="mt-4">
                        {actionPhase && (
                          actionPhase?.alerts?.map((msg) => (
                            <AlertInfo
                              description={msg}
                            />
                          ))
                        )}
                      </div>


                    </Scrollbar>
                  </CardContent>
                </Card>
              </div>


              <Connector />
              {/* Right column (Actions) */}
              <div className="w-full flex flex-col">
                <Card className="flex flex-col flex-1 min-h-0">
                  <CardHeader>
                    <div className="flex justify-between gap-2">
                      <CardTitle>Faça isso...</CardTitle>
                      {reactionPhase && (
                        <Button onClick={() => setReactionPhase(null)} className="bg-red-200 dark:bg-red-500/10">
                          <Iconify icon="ic:baseline-close" />
                        </Button>
                      )}
                    </div>
                  </CardHeader>
                  <CardContent className="flex-1 min-h-0 overflow-hidden">
                    <ScrollArea className="h-full">
                      <div className="py-4 bg-slate-100 dark:bg-[#1A1D21]">
                        <div className="container mx-auto">
                          {/* Renderizar Blocos */}
                          {blocks.map((block, index) => (
                            <div key={block.id} className="relative">
                              {/* Bloco Individual */}
                              <Card>
                                <CardHeader>
                                  <div className="flex justify-between gap-2">
                                    <Select
                                      className="bg-slate-500 dark:bg-[#1A1D21] w-full"
                                      onValueChange={(value) => updateBlockType(block.id, value)}
                                      value={block.value}
                                    >
                                      <SelectTrigger>
                                        <SelectValue placeholder="Selecione uma ação" />
                                      </SelectTrigger>
                                      <SelectContent>
                                        {Object.keys(groupedActions).map((category, index) => (
                                          <div key={index}>
                                            <h3 className="font-bold text-sm text-gray-700 dark:text-[#D1D2D3] capitalize px-2 py-1">{category}</h3>
                                            {groupedActions[category].map((event, eventIndex) => (
                                              <SelectItem key={eventIndex} value={event.value}>
                                                <div className="flex items-center gap-2">
                                                  <Iconify icon={event.icon} className="mr-2" />
                                                  {event.name}
                                                </div>
                                              </SelectItem>
                                            ))}
                                          </div>
                                        ))}
                                      </SelectContent>
                                    </Select>
                                    <Button
                                      variant="ghost"
                                      className="bg-red-100 dark:bg-red-500/10"
                                      onClick={() => removeBlock(block.id)}
                                    >
                                      <Iconify icon="mdi:delete-outline" />
                                    </Button>
                                  </div>
                                </CardHeader>
                                <CardContent>
                                  {/* Seleção do tipo de bloco */}
                                  <div className="">
                                    {block.value === "to.funnel.cardTransferUser" && (
                                      <CardTransferCard
                                        user={user}
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.chat.addNote" && (
                                      <ChatAddNoteComponent
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.httpRequest" && (
                                      <HttpRequestComponent
                                        block={block}
                                        availableVariables={availableVariables}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.chat.sendMessage" && (
                                      <CardSendMessage
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                        actionState={actionState}
                                        actionPhase={actionPhase}
                                        canais={canais}
                                      />
                                    )}
                                    {block.value === "to.chat.addTag" && (
                                      <ChatAddTag
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.chat.removeTag" && (
                                      <ChatRemoveTag
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.funnel.cardCreate" && (
                                      <CardNewLead
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.moveCardStage" && (
                                      <CardReactionMoverCardFunil
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.funnel.action" && (
                                      <CardChangeValue
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {block.value === "to.sendMake" && (
                                      <CardSendMake
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}

                                    {block.value === "to.chat.finish" && (
                                      <CardFinishChat
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}

                                    {block.value === "to.chat.transfer" && (
                                      <CardTransferChat
                                        user={user}
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                      />
                                    )}
                                    {
                                      block.value === "to.chat.assign" && (
                                        <CardAssignChat
                                          user={user}
                                          block={block}
                                          changeBlock={(event) => handleChangeBlock(block.id, event)}
                                        />
                                      )
                                    }
                                    {block.value === "to.condition" && (
                                      <CardCondition
                                        block={block}
                                        changeBlock={(event) => handleChangeBlock(block.id, event)}
                                        availableVariables={availableVariables}
                                        actionPhase={actionPhase}
                                        actionState={actionState}
                                        canais={canais}
                                        user={user}
                                      />
                                    )}
                                  </div>
                                </CardContent>
                              </Card>
                              {/* Conector entre os blocos */}
                              {index < blocks.length - 1 && (
                                <div className="flex justify-center items-center">
                                  <div className="relative w-2 h-12 flex justify-center">
                                    {/* Linha vertical */}
                                    <div className="absolute w-0.5 bg-gray-300 dark:bg-[#383838] h-full"></div>
                                    {/* Círculo no centro */}
                                    <div className="absolute w-3 h-3 bg-violet-500 rounded-full top-1/2 -translate-y-1/2"></div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ))}
                          {/* Botão para adicionar mais blocos */}
                          {actionPhase && isActionValid ? (
                            <div className="flex justify-center mt-4">
                              <Button variant="outline" onClick={addBlock} className="flex items-center">
                                <Iconify icon="mdi:plus-circle-outline" className="mr-2" />
                                Adicionar Ação
                              </Button>
                            </div>
                          ) : (
                            <div className="mt-4">
                              <div className="bg-red-50 dark:bg-red-500/10 p-4 rounded border-red-200 dark:border-red-500/20 border">
                                <p className="text-red-800 dark:text-red-400 text-sm">Preencha todos os campos na coluna ao lado para prosseguir</p>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </ScrollArea>
                  </CardContent>
                </Card>
              </div>
            </div>
          )
        }


        </div>
      </div>
    </>
  );
}